import { useSelector } from "react-redux";
import { RootState } from "../../../configureStore";
import { FormExtractions } from "../../../interface/returns";
import { useFormConfig } from "../../../hooks/useFormConfig";

/**
 * Renders one <FormConfigLoader/> per available form type to eagerly trigger config
 * loading for every form in the extract task. Once each config is in Redux,
 * `useDateValidationScan` walks them and surfaces invalid date fields across every
 * page — including pages the user has not navigated to yet.
 *
 * Returns null; purely for side effects.
 */
const TaskValidator = ({ availableFormTypes }: { availableFormTypes: string[] }) => (
    <>
        {availableFormTypes.map((formType) => (
            <FormConfigLoader key={formType} formType={formType} />
        ))}
    </>
);

const FormConfigLoader = ({ formType }: { formType: string }) => {
    // Pick the tax year from the first extraction so we load the year-specific config
    // (e.g., 1040-2025) rather than the default. The task is for a single return so all
    // extractions in this form share the same year in practice.
    const taxYear = useSelector<RootState, number | undefined>(
        ({ returns }) =>
            returns.extractedJson?.[formType as keyof FormExtractions]?.extraction?.[0]?.extractedData?.taxYear,
    );
    useFormConfig(formType, taxYear);
    return null;
};

export default TaskValidator;
